<template>
  <v-app>
    <router-view exa />
  </v-app>
</template>

<script>

import "vue-loading-overlay/dist/vue-loading.css";

import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "App",
  components: {
  },
};
</script>

<style lang="scss">
// #main {
//   margin-left: 14px;
// }

.v-content {
  background-color: #f2f3f8;
}

#whoLogged {
  position: absolute;
  float: right;
  top: 24px;
  right: 24px;
  color: gray;
}

aside {
  box-shadow: none !important;
}

tbody tr:nth-of-type(even) {
  background-color: white;
}

p {
  padding: 0 !important;
  margin: 0 !important;
}

.add-person-button {
  padding-top: 4px;
  padding-left: 2px;
}

table.v-table thead th:first-child {
  padding: 0 4px !important;
}

table.v-table thead th:not(:first-child) {
  padding: 0 4px !important;
}

tr {
  border: 1px solid white;
  border-bottom: 0;
}

.v-date-picker-table {
  position: relative;
  padding: 0 12px;
  height: 300px !important;
}

.row {
  margin-left: 0px !important;
  margin-right: 2px !important;
}

.input-group.input-group--error label {
  animation: none !important;
}

a:link {
  text-decoration: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

input[type=number] {
  -moz-appearance: textfield !important;
}

.btn {
  text-transform: unset !important;
}

.v-label {
  font-size: 12px !important;
}


.input-text {
  ::v-deep {
    .v-text-field {
      input {
        color: blue !important;
      }
    }
  }
}
</style>
